import { Box, Heading } from '@radix-ui/themes'
import React, { useEffect } from 'react'

export const ErrorPage: React.FC<{ message: string }> = ({ message }) => {

  useEffect(() => {
    // Установить заголовок вкладки
    document.title = message
  })

  return (
    <Box py="4" px="4">
      <Heading color="crimson" as="h2">{message}</Heading>
    </Box>
  )
}
